require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-is-the-world-bank-fully-leveraging-nature-for-clim.json") })
        }
      }, "path---en-us-update-is-the-world-bank-fully-leveraging-nature-for-clim");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-is-the-world-bank-fully-leveraging-nature-for-clim!./.cache/json/en-us-update-is-the-world-bank-fully-leveraging-nature-for-clim.json
// module id = 766
// module chunks = 231608221292675